import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { findProductDayData, updateProductData } from '@/service/production/yieldCorrection';
export default function useGuliaoSaleData(params) {
  var productDayData = ref({
    deviceProList: [],
    totalPro: {
      main_run: '',
      main_pro: '',
      create_time: '',
      hour_main_pro: '',
      hour_stone_pro: '',
      electric: '',
      stone_pro: '',
      stone_run: '',
      id: 0,
      electric_ton: '',
      day_time: ''
    }
  });
  // 获取主机汇总数据
  var findProductDayDataAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return findProductDayData(params.value);
          case 2:
            data = _context.sent;
            productDayData.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function findProductDayDataAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var summaryData = computed(function () {
    return [{
      num: productDayData.value.totalPro.main_pro,
      desc: '主机产量/吨'
    }, {
      num: productDayData.value.totalPro.stone_pro,
      desc: '制砂产量/吨'
    }];
  });
  var updateProductDataAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(updateParams) {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return updateProductData(updateParams);
          case 2:
            data = _context2.sent;
            return _context2.abrupt("return", data);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function updateProductDataAsync(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return [productDayData, summaryData, findProductDayDataAsync, updateProductDataAsync];
}